export const PAYMENT_GATEWAYS_API = '/api/dashboard/customer/settings/payment-gateways'

export const CONNECTED_PAYMENT_INTEGRATIONS_API =
  '/api/dashboard/customer/settings/connected-integrations'
